<template>
  <div
    class="grid grid-cols-[30px_auto_10px] items-center gap-2 cursor-pointer mb-0 text-gray-500 -mr-4"
    data-test="project-navbar-item"
    @click="handleClick"
  >
    <img
      class="size-6 rounded-full"
      :src="project.attributes.picture_login_url_m"
    />
    <div
      class="truncate text-sm"
      :class="{ 'font-bold has-text-primary text-shadow-2xs': is_active }"
    >
      {{ project.attributes.name }}
    </div>
    <FontAwesomeIcon
      v-if="!is_active"
      class="text-gray-400 text-xs"
      :icon="['fa', 'chevron-down']"
      style="margin-bottom: 1px"
    />
    <FontAwesomeIcon
      v-else
      class="text-gray-400 text-xs"
      :icon="['fa', 'chevron-up']"
    />
  </div>
  <div
    v-if="is_active"
    class="flex flex-col ml-3 gap-1"
  >
    <AppLink
      v-for="item in routes_active"
      :key="item.name"
      class="hover:bg-gray-100 rounded-full px-3 py-1"
      :class="{
        'has-background-primary-light shadow-sm':
          route.name.startsWith(item.prefix) && project.id === route.params.project_id,
      }"
      :data-test="item.data_test"
      :title="!mq.isMobile ? $t(item.title) : ''"
      :to="{ name: item.name, params: { project_id: project.id } }"
      @click="mq.isMobile && emit('close')"
    >
      <div>
        <div
          :class="[
            route.name.startsWith(item.prefix) && project.id === route.params.project_id
              ? 'font-bold has-text-primary text-shadow-2xs text-sm'
              : 'text-gray-500 text-sm font-medium',
          ]"
        >
          {{ $t(item.title) }}
        </div>
      </div>
    </AppLink>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import {
  NAVBAR_ITEMS_PARTNERS_PROJECT,
  NAVBAR_ITEMS_PARTNERS_PROJECT_ACTIVE_ROLE_NEEDED,
} from '@/app/data/navbar_constants';
import { useStore } from 'vuex';

const store = useStore();

const { proxy: app } = getCurrentInstance();

const route = useRoute();

const current_profile = computed(() => store.getters.current_profile);

const props = defineProps({
  project: { type: Object, required: true },
  is_active: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);

const handleClick = () => {
  emit('toggle', props.project.id);
};

const is_route_active = (r) => {
  if (r.flipper && !app.$flipper.enabled(r.flipper)) return false;
  if (!props.project) return false;
  if (NAVBAR_ITEMS_PARTNERS_PROJECT_ACTIVE_ROLE_NEEDED.includes(r.name)) {
    return current_profile.value.attributes.active_role_project_ids.includes(parseInt(props.project.id, 10));
  }
  return true;
};

const routes_active = computed(() => NAVBAR_ITEMS_PARTNERS_PROJECT.filter(is_route_active));
</script>
